var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResurs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 377.94666 58.013332",
    height: 58.013332,
    width: 377.94666,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,58.013333)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#236161",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 326.293,435.059 c -117.324,0 -212.902,-92.891 -217.316,-209.129 4.367,86.199 75.644,154.746 162.933,154.746 90.102,0 163.149,-73.043 163.149,-163.145 h 108.765 c 0,120.137 -97.394,217.528 -217.531,217.528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#c6571e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 271.91,54.3828 c -90.101,0 -163.148,73.0432 -163.148,163.1482 H 0 C 0,97.3945 97.3906,0 217.527,0 334.852,0 430.426,92.8906 434.844,209.133 430.477,122.934 359.199,54.3828 271.91,54.3828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#3aa497",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 435.059,217.527 c 0,90.106 -73.043,163.149 -163.149,163.149 -90.105,0 -163.148,-73.043 -163.148,-163.149 h 326.297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#d7bb19",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 108.762,217.527 c 0,-90.101 73.047,-163.1442 163.148,-163.1442 90.106,0 163.149,73.0432 163.149,163.1442 H 108.762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#050606",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 950.535,0 -83.152,120.102 h -91.77 V 0 h -99.777 v 431.137 h 186.621 c 38.188,0 71.34,-6.367 99.473,-19.094 28.117,-12.73 49.78,-30.793 64.97,-54.195 15.19,-23.407 22.8,-51.125 22.8,-83.153 0,-32.027 -7.7,-59.644 -23.1,-82.84 -15.4,-23.199 -37.264,-40.957 -65.596,-53.273 L 1057.7,0 Z m -25.254,330.438 c -15.609,12.933 -38.398,19.402 -68.363,19.402 H 775.613 V 199.555 h 81.305 c 29.965,0 52.754,6.562 68.363,19.711 15.598,13.136 23.407,31.609 23.407,55.429 0,24.227 -7.809,42.809 -23.407,55.743"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#050606",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1567.79,10.1641 c -26.28,6.7734 -47.22,15.289 -62.82,25.5586 L 1537,104.703 c 14.78,-9.4491 32.64,-17.1483 53.58,-23.0936 20.94,-5.9571 41.47,-8.9336 61.59,-8.9336 40.65,0 60.98,10.0586 60.98,30.1792 0,9.442 -5.55,16.215 -16.63,20.329 -11.09,4.097 -28.13,7.593 -51.12,10.468 -27.1,4.102 -49.49,8.825 -67.14,14.168 -17.66,5.332 -32.95,14.782 -45.88,28.332 -12.94,13.551 -19.4,32.844 -19.4,57.895 0,20.941 6.05,39.516 18.17,55.738 12.1,16.219 29.76,28.844 52.96,37.883 23.2,9.023 50.6,13.551 82.23,13.551 23.41,0 46.7,-2.574 69.91,-7.703 23.19,-5.137 42.39,-12.219 57.58,-21.25 l -32.02,-68.364 c -29.16,16.414 -60.98,24.637 -95.47,24.637 -20.54,0 -35.94,-2.879 -46.19,-8.625 -10.27,-5.754 -15.4,-13.144 -15.4,-22.172 0,-10.269 5.54,-17.457 16.63,-21.558 11.08,-4.106 28.73,-8.008 52.97,-11.7 27.1,-4.523 49.27,-9.343 66.52,-14.476 17.24,-5.137 32.22,-14.473 44.96,-28.024 12.72,-13.546 19.09,-32.437 19.09,-56.664 0,-20.5348 -6.16,-38.7966 -18.48,-54.8161 C 1774.12,34.4922 1756.16,22.0664 1732.55,13.2422 1708.93,4.41797 1680.91,0 1648.48,0 c -27.52,0 -54.42,3.39063 -80.69,10.1641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#050606",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2597.52,10.1641 c -26.28,6.7734 -47.22,15.289 -62.82,25.5586 l 32.03,68.9803 c 14.78,-9.4491 32.64,-17.1483 53.58,-23.0936 20.94,-5.9571 41.47,-8.9336 61.59,-8.9336 40.65,0 60.98,10.0586 60.98,30.1792 0,9.442 -5.55,16.215 -16.64,20.329 -11.08,4.097 -28.12,7.593 -51.11,10.468 -27.1,4.102 -49.49,8.825 -67.14,14.168 -17.66,5.332 -32.95,14.782 -45.88,28.332 -12.94,13.551 -19.41,32.844 -19.41,57.895 0,20.941 6.06,39.516 18.18,55.738 12.1,16.219 29.76,28.844 52.96,37.883 23.19,9.023 50.61,13.551 82.23,13.551 23.4,0 46.7,-2.574 69.9,-7.703 23.2,-5.137 42.4,-12.219 57.59,-21.25 l -32.03,-68.364 c -29.16,16.414 -60.97,24.637 -95.46,24.637 -20.54,0 -35.94,-2.879 -46.2,-8.625 -10.26,-5.754 -15.39,-13.144 -15.39,-22.172 0,-10.269 5.54,-17.457 16.62,-21.558 11.09,-4.106 28.74,-8.008 52.97,-11.7 27.11,-4.523 49.28,-9.343 66.52,-14.476 17.25,-5.137 32.23,-14.473 44.96,-28.024 12.73,-13.546 19.1,-32.437 19.1,-56.664 0,-20.5348 -6.16,-38.7966 -18.48,-54.8161 C 2803.85,34.4922 2785.88,22.0664 2762.28,13.2422 2738.66,4.41797 2710.64,0 2678.21,0 c -27.52,0 -54.42,3.39063 -80.69,10.1641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#050606",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2197.39,337.91 h -96.08 V 164.836 c 0,-53.383 -22.37,-80.0665 -67.13,-80.0665 v -0.0078 0 0.0078 c -44.76,0 -67.13,26.6835 -67.13,80.0665 V 337.91 h -96.09 V 150.676 c 0,-25.141 3.36,-47.082 9.98,-65.9143 h -0.02 C 1898.01,34.5039 1940.85,0 2034.18,0 c 93.33,0 136.16,34.5039 153.26,84.7617 h -0.03 c 6.63,18.8323 9.98,40.7733 9.98,65.9143 V 337.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#050606",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1429.94,258.375 c -15.4,26.07 -36.54,46.395 -63.44,60.977 -26.89,14.57 -56.97,21.863 -90.23,21.863 -32.43,0 -61.79,-6.988 -88.07,-20.942 -26.28,-13.964 -46.91,-33.98 -61.91,-60.05 -14.98,-26.082 -22.47,-56.356 -22.47,-90.848 0,-1.23 0.61,-9.855 1.84,-25.867 h 250.68 c -4.51,-20.535 -15.19,-36.754 -32.03,-48.6564 -16.83,-11.918 -37.77,-17.8633 -62.82,-17.8633 -17.25,0 -32.54,2.5586 -45.89,7.6992 -13.34,5.1289 -25.76,13.2422 -37.26,24.3285 L 1127.22,53.582 C 1158.43,17.8594 1204.01,0 1263.95,0 c 37.37,0 70.42,7.28516 99.16,21.8633 28.75,14.5703 50.92,34.8008 66.52,60.668 15.61,25.8707 23.41,55.2227 23.41,88.0777 0,32.43 -7.7,61.688 -23.1,87.766 m -208.49,-8.625 c 14.78,12.523 32.86,18.789 54.2,18.789 21.77,0 40.04,-6.16 54.82,-18.48 13.39,-11.157 22.01,-26.059 25.97,-44.625 h -160.93 c 3.97,18.199 12.58,32.992 25.94,44.316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#050606",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2477.1,248.699 31.64,86.91 c -5.83,0.52 -11.82,0.774 -18,0.68 -22.58,-0.34 -42.95,-4.184 -61.83,-11.777 -18.89,-7.606 -36.72,-21.481 -47.81,-36.879 v 43.73 h -91.77 V 0 h 96.09 v 163.828 c 0,28.867 10.68,48.938 24.01,62.492 14.21,14.45 35.1,21.032 55.44,22.239 4.3,0.257 8.33,0.273 12.23,0.14"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResurs);
export default __webpack_public_path__ + "static/media/resurs.81cd71e73d6bd1806132cccb12d75174.svg";
export { ForwardRef as ReactComponent };